module.exports = __webpack_public_path__ + "img/logo-zhiyun2.5e24ac50.png";